import { defineStore } from 'pinia';

export const useBookmarkStore = defineStore('bookmark', {
  state   : () => ({
    bookmarks        : {},
    currentBookmarks : {}
  }),
  actions : {
    setBookmarks(bookmarks) {

      this.bookmarks = bookmarks;
    },
    addBookmark(bookmark) {

      this.bookmarks.push(bookmark);
    },
    deleteBookmark(id) {

      this.bookmarks = this.bookmarks.filter(bookmark => bookmark.id !== id);
    },
    setCurrentBookmark(model, bookmark) {

      this.currentBookmarks = { ...this.currentBookmarks, [model] : bookmark };
    },
    deleteCurrentBookmark(model) {

      delete this.currentBookmarks[model];
    }
  }
});